import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';
import { ToggleControl, BaseControl } from '@wordpress/components';

const InspectorCheckbox = ( props ) => {
	const { label, value, onChange = () => {} } = props;
	// const [selectedValue, setSelectedValue] = useState(value);

	// useEffect(()=>{
	//   onChange(selectedValue);
	// },[selectedValue])

	return (
		<BaseControl>
			<ToggleControl
				label={ label }
				checked={ value === true }
				onChange={ ( val ) => onChange( val ) }
				__nextHasNoMarginBottom={ true }
			/>
		</BaseControl>
	);
};

export default InspectorCheckbox;
